module.exports = __webpack_public_path__ + "static/oec.a27e2abe.png";